import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";import * as S from "../../../CompareTable.styles";
import type { NotesProps } from "./Notes.types";

export const Notes = ({ products }: NotesProps) => {
  const { formatMessage } = useModelCompareTranslation();
  return (
    <>
      <S.EmptyPropertyTitleGridItem stickX />
      {products.map((product, index) =>
        product?.notes?.length ? (
          <S.NotesWrap key={`${product.id}-${index}`}>
            {product.notes.map((note, i) => (
              <S.Note key={i}>{formatMessage(note)}</S.Note>
            ))}
          </S.NotesWrap>
        ) : (
          <S.CenterPlaceholderGridItem key={`${product.id}-${index}`} />
        ),
      )}
    </>
  );
};
